"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var SiteHeader = /*#__PURE__*/function (_window$AbstractEleme) {
    _inherits(SiteHeader, _window$AbstractEleme);

    var _super = _createSuper(SiteHeader);

    function SiteHeader(id, options) {
      var _this;

      _classCallCheck(this, SiteHeader);

      var OPTIONS_MANDATORY = {
        watchResize: true
      };
      options = $.extend(true, _.clone(options), OPTIONS_MANDATORY);
      _this = _super.call(this, id, options);
      _this.$mainBar = _this.$domElement.find(".site-header__mainbar");
      _this.$mainBarMenu = _this.$mainBar.find(".site-header__menu.navbar-nav");
      _this.$mainBarInnerMenu = _this.$domElement.find(".site-header__innermenu");
      _this.$mainBarInnerMenuContent = _this.$mainBarInnerMenu.find(".site-header__innermenu-content");
      _this.$mainBarInnerMenuCard = _this.$mainBarInnerMenuContent.find(".card.site-header__innermenu-card");
      _this.$navLinks = _this.$domElement.find(".site-header__mainbar *[data-quickmenu-target], .site-header__extrabar *[data-quickmenu-target]");
      _this.$hamburgerBtn = _this.$mainBar.find(".hamburger-btn");
      _this.$searchBtns = _this.$domElement.find(".search-btn, #site-header__innermenu-search-card-header");
      _this.$quickCartBtn = _this.$domElement.find(".quick-chart-btn");
      _this.$accountBtn = _this.$domElement.find(".account-btn");
      _this.$ticker = _this.$domElement.find(".site-header__ticker");
      _this.$asideLogoSvg = _this.$domElement.find("#site-header__logo-aside-svg");
      _this.$topLogoSvg = _this.$domElement.find("#site-header__logo-top-svg");
      _this.currentScrollTop = _this.savedScrolldownPosition = $(window).scrollTop();
      _this.scrolltopPositionOnMenuHide = null;
      _this.logoLoopTL = null;
      _this.$refHtmlBody = $("html, body");
      return _this;
    }

    _createClass(SiteHeader, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        this.$domElement.find(".it-lang-btn").on("click", this.options.changeLanguageCallback);
        this.$domElement.find(".en-lang-btn").on("click", this.options.changeLanguageCallback);
        this.$domElement.find(".es-lang-btn").on("click", this.options.changeLanguageCallback);
        this.$mainBarInnerMenuCard.on('shown.bs.collapse.' + this.id, function (event) {
          event.stopPropagation();
          TweenMax.to(_this2.$mainBarInnerMenu, 0.65, {
            scrollTo: event.delegateTarget,
            ease: Expo.easeInOut
          });
        });
        this.$ticker.cycle({
          slides: "> .ticker-item",
          speed: 250,
          timeout: 10000
        });
        this.$navLinks.on("pointerenter", function (event) {
          _this2.$mainBarInnerMenuCard.removeClass("force-visibility");

          if (!$("html").hasClass("user-logged") && $(event.delegateTarget).attr("id") == "account-btn") {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
          } else if (window.Breakpoints.matches(window.Breakpoints.MIN_WIDTH, window.Breakpoints.LG)) {
            if ($(event.delegateTarget).attr("data-quickmenu-target") != "") {
              var ID = $(event.delegateTarget).attr("data-quickmenu-target");

              if (ID && ID != "") {
                $(ID).addClass("force-visibility");

                _this2.$domElement.off("pointerleave").one("pointerleave", function (event) {
                  _this2.$mainBarInnerMenuCard.removeClass("force-visibility");
                });
              }
            }
          }
        });
        this.$searchBtns.on("click", function (event) {
          event.stopPropagation();

          _this2.close();

          _this2.options.showSearchModalCallback();
        });
        this.$hamburgerBtn.on("click", function (event) {
          if (Detectizr.os.name.match("ios")) {
            if (!$("html").hasClass("minimized-menu-visible")) {
              $("html").attr("last-scroll-position", $(window).scrollTop());
            }
          }

          $("html").toggleClass("minimized-menu-visible");

          if (Detectizr.os.name.match("ios")) {
            if (!$("html").hasClass("minimized-menu-visible")) {
              window.TweenMax.set(window, {
                scrollTo: {
                  y: $("html").attr("last-scroll-position")
                }
              });
              $("html").removeAttr("last-scroll-position");
            }
          }

          window.TweenMax.set(_this2.$mainBarInnerMenu, {
            scrollTo: {
              y: 0,
              autoKill: false
            }
          });

          _this2.$mainBarInnerMenuCard.find(".site-header__innermenu-body-wrapper").collapse('hide');
        });
        this.$accountBtn.on("click", function (event) {
          if ($("html").hasClass("user-logged")) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
          }
        });

        if (Globals.IS_QUICK_PRODUCT_AUTHORIZED_DEVICE_TYPE) {
          $(window).on("scroll." + this.id, _.throttle(this._mobileScrollHandler.bind(this), 100, []));

          this._mobileScrollHandler();
        }

        _get(_getPrototypeOf(SiteHeader.prototype), "init", this).call(this); // FIX TURBOLINKS BUG ON 1st LEVEL MENU BUTTONS


        $(".site-header__menu a").on("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          window.pageVisitRequest = {
            url: $(event.delegateTarget).attr("href"),
            needsPreventDefault: true
          };
          Turbolinks.visit(window.pageVisitRequest.url);
        });
      }
    }, {
      key: "close",
      value: function close() {
        this.$domElement.off("pointerleave");
        this.$mainBarInnerMenuCard.removeClass("force-visibility");
        $("html").removeClass("minimized-menu-visible");
        this.$mainBarInnerMenuCard.find(".site-header__innermenu-body-wrapper[data-parent]").collapse('hide');
        window.TweenMax.set(this.$mainBarInnerMenu, {
          scrollTo: {
            y: 0,
            autoKill: false
          }
        });
      }
    }, {
      key: "turbolinksLoad",
      value: function turbolinksLoad() {
        $("body").hasClass("template-cart") ? this._disableQuickCartBtn() : this._enableQuickCartBtn();

        if (Globals.IS_QUICK_PRODUCT_AUTHORIZED_DEVICE_TYPE) {
          this.show();
        } else if ($("body").hasClass("template-index")) {
          $(window).on("scroll." + this.id, _.throttle(this._scrollHandler.bind(this), 100, []));

          this._scrollHandler();
        } else {
          $(window).off("scroll." + this.id);

          this._hideExpandedMenu(false);
        }
      }
    }, {
      key: "_loopLogoAnimation",
      value: function _loopLogoAnimation() {
        var isLogoVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        this._killLoopLogoAnimation();

        if (this.isVisible) {
          var $target = !this.isExpanded && window.Breakpoints.matches(window.Breakpoints.MIN_WIDTH, window.Breakpoints.XL) ? this.$asideLogoSvg : this.$topLogoSvg;
          var $chars = $target.find("g[char]");
          var charsArray = [];
          var subcharsArray = [];
          $chars.each(function (i, el) {
            charsArray[i] = $(el);
            subcharsArray[i] = [];
            $(el).find("> *").each(function (index, element) {
              subcharsArray[i].push($(element));
            });
          });
          this.logoLoopTL = new window.TimelineMax({
            repeat: -1
          });
          this.logoLoopTL.set(charsArray, {
            visibility: "hidden",
            x: 0,
            opacity: 1,
            scale: 1,
            transformOrigin: "left center"
          });
          this.logoLoopTL.addLabel("draw_start", "+=0.5");
          this.logoLoopTL.set(charsArray, {
            visibility: "visible"
          }, "draw_start");

          for (var i = 0, len = subcharsArray.length; i < len; i++) {
            this.logoLoopTL.staggerFromTo(subcharsArray[i], 0.7, {
              drawSVG: "0%"
            }, {
              drawSVG: "100%",
              ease: window.Cubic.easeOut
            }, 0.15, "draw_start+=" + (0.15 * i).toString());
          }

          this.logoLoopTL.addLabel("draw_complete");
          this.logoLoopTL.addLabel("undraw_start", "+=45");

          for (var _i = 0, _len = charsArray.length; _i < _len; _i++) {
            this.logoLoopTL.to(charsArray[_i], 0.75 + 0.012 * _i, {
              force3D: "auto",
              scale: 1 - 0.025 * _i,
              x: -35,
              opacity: 0,
              ease: window.Expo.easeInOut
            }, "undraw_start+=" + 0.025 * _i);
          }

          this.logoLoopTL.addLabel("undraw_complete");
          if (isLogoVisible) this.logoLoopTL.seek("draw_complete");
        }
      }
    }, {
      key: "_killLoopLogoAnimation",
      value: function _killLoopLogoAnimation() {
        if (this.logoLoopTL) {
          this.logoLoopTL.kill();
          this.logoLoopTL = null;
        }
      }
    }, {
      key: "_enableQuickCartBtn",
      value: function _enableQuickCartBtn() {
        var _this3 = this;

        this.$quickCartBtn.prop("disabled", false);
        this.$quickCartBtn.off("click").on("click", function (event) {
          event.preventDefault();

          if (!Globals.checkCookieBeforeUsingCart()) {
            return;
          }

          _this3.close();

          _this3.options.showQuickCartCallback();

          _this3.pushViewCartDataLayer();
        });
      }
    }, {
      key: "pushViewCartDataLayer",
      value: function pushViewCartDataLayer() {
        console.log('-----> pushViewCartDataLayer');
        this.killAJAXRequest();
        this.AJAXrequest = $.ajax({
          dataType: "json",
          url: "/cart.js",
          success: function success(data) {
            // console.log('cart data', data);
            var products = [];

            for (var k = 0, len = data.items.length; k < len; k++) {
              var inventory_quantity = data.items[k].quantity;
              var temp_pr = {
                item_id: data.items[k].product_id.toString(),
                item_name: data.items[k].product_title,
                currency: Shopify.currency.active,
                item_brand: data.items[k].vendor,
                item_category: "Apparel",
                item_category2: data.items[k].variant_options[1],
                item_category3: undefined,
                item_category4: undefined,
                price: Number(slate.Currency.formatMoney(data.items[k].price, Globals.moneyFormat).toString().replace('€', '').replace('.', '').replace(',', '.')),
                available_quantity: inventory_quantity,
                quantity: 1,
                item_variant: data.items[k].variant_id.toString()
              };
              products.push(temp_pr);
            }
            /* console.log('dataLayerPush', {
            	event: "view_cart",
            	ecommerce: {
            		items: products
            	}
            }); */


            dataLayer.push({
              ecommerce: null
            });
            dataLayer.push({
              event: "view_cart",
              ecommerce: {
                items: products
              }
            });
            Globals.CART_ITEMS = products;
          },
          error: function error(err) {
            console.log(err);
          }
        });
      }
    }, {
      key: "killAJAXRequest",
      value: function killAJAXRequest() {
        if (this.AJAXrequest) {
          this.AJAXrequest.abort();
          this.AJAXrequest = null;
        }
      }
    }, {
      key: "_disableQuickCartBtn",
      value: function _disableQuickCartBtn() {
        this.$quickCartBtn.off("click");
        this.$quickCartBtn.prop("disabled", true);
      }
    }, {
      key: "_scrollHandler",
      value: function _scrollHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        this.savedScrolldownPosition = this.currentScrollTop;
        this.currentScrollTop = $(window).scrollTop();

        if ($("body").hasClass("template-index")) {
          if (window.Breakpoints.matches(window.Breakpoints.MIN_WIDTH, window.Breakpoints.XL) && $(window).scrollTop() <= 180) {
            if (!$("html").hasClass("expanded-header")) {
              this.$domElement.off("pointerleave");
              this.$mainBarInnerMenuCard.removeClass("force-visibility");
              $("html").addClass("expanded-header");
              window.TweenMax.killTweensOf(this.$domElement);
              window.TweenMax.set(this.$domElement, {
                clearProps: "all"
              });

              this._loopLogoAnimation();
            }
          } else {
            this._hideExpandedMenu();
          }
        }
      }
    }, {
      key: "_mobileScrollHandler",
      value: function _mobileScrollHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (this.$refHtmlBody.hasClass("disable-native-scrolling")) {
          return;
        }

        if (window.TweenMax.isTweening(window)) {
          return;
        }

        this.savedScrolldownPosition = this.currentScrollTop;
        this.currentScrollTop = $(window).scrollTop();

        if (this.currentScrollTop <= window.ViewportUtils.$window.height() / 3) {
          this.show();
        } else if (this.currentScrollTop > this.savedScrolldownPosition) {
          this.hide();
        } else if (this.scrolltopPositionOnMenuHide && this.currentScrollTop < this.scrolltopPositionOnMenuHide - 60) {
          this.show();
        }
      }
    }, {
      key: "_hideExpandedMenu",
      value: function _hideExpandedMenu() {
        var isAnimated = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        if ($("html").hasClass("expanded-header")) {
          this.$domElement.off("pointerleave");
          this.$mainBarInnerMenuCard.removeClass("force-visibility");
          window.TweenMax.killTweensOf(this.$domElement);
          window.TweenMax.set(this.$domElement, {
            visibility: "hidden"
          });
          $("html").removeClass("expanded-header");
          window.TweenMax.fromTo(this.$domElement, isAnimated ? 0.15 : 0, {
            visibility: "hidden",
            y: -200
          }, {
            delay: 0.15,
            force3D: "auto",
            visibility: "visible",
            y: 0,
            clearProps: "all",
            ease: window.Sine.easeOut
          });

          this._loopLogoAnimation();
        }
      }
    }, {
      key: "resizeHandler",
      value: function resizeHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        this.close();

        if (Globals.IS_QUICK_PRODUCT_AUTHORIZED_DEVICE_TYPE) {
          this._mobileScrollHandler();
        } else if ($("body").hasClass("template-index")) {
          $("html").removeClass("expanded-header");

          this._scrollHandler();
        }

        this._loopLogoAnimation();
      }
    }, {
      key: "show",
      value: function show() {
        if ($("html").hasClass("site-header-hidden")) {
          $("html.site-header-hidden").removeClass("site-header-hidden");
          this.$ticker.cycle("resume");

          this._loopLogoAnimation(true);

          this.scrolltopPositionOnMenuHide = null;

          _get(_getPrototypeOf(SiteHeader.prototype), "show", this).call(this);
        }
      }
    }, {
      key: "hide",
      value: function hide() {
        this.scrolltopPositionOnMenuHide = this.currentScrollTop;
        if ($("html").hasClass("site-header-hidden")) return;
        $("html").addClass("site-header-hidden");
        this.$ticker.cycle("pause");

        this._killLoopLogoAnimation();

        _get(_getPrototypeOf(SiteHeader.prototype), "hide", this).call(this);
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this._killLoopLogoAnimation();

        this.$ticker.cycle('destroy');
        this.$domElement.find(".it-lang-btn").off("click");
        this.$domElement.find(".en-lang-btn").off("click");
        this.$domElement.find(".es-lang-btn").off("click");
        this.$searchBtns.off("click");
        this.$hamburgerBtn.off("click");
        this.$quickCartBtn.off("click");
        this.$navLinks.off("pointerenter");
        $(window).off("scroll." + this.id);
        this.$mainBarInnerMenuCard.off('shown.bs.collapse.' + this.id);

        _get(_getPrototypeOf(SiteHeader.prototype), "dispose", this).call(this);
      }
    }, {
      key: "currentHeight",
      get: function get() {
        return this.$domElement.outerHeight();
      }
    }, {
      key: "isVisible",
      get: function get() {
        return !$("html").hasClass("site-header-hidden");
      }
    }, {
      key: "isHidden",
      get: function get() {
        return $("html").hasClass("site-header-hidden");
      }
    }, {
      key: "isExpanded",
      get: function get() {
        return $("html").hasClass("expanded-header");
      }
    }, {
      key: "cartQuantity",
      set: function set(quantity) {
        this.$quickCartBtn.attr("data-quantity", quantity ? quantity : "0");
      }
    }]);

    return SiteHeader;
  }(window.AbstractElement);

  window.SiteHeader = SiteHeader;
})(window);
